<template>
  <header
    class="flex max-w-[53rem] flex-col gap-6"
    :class="[bgColor, isCenter ? 'items-center' : '', isCentered ? 'mx-auto' : '']"
  >
    <div
      class="space-y-4"
      :class="{
        'text-text-light': isDarkMode,
        'text-center': isCenter,
      }"
    >
      <p v-if="tagline" class="tagline text-text-accent">
        {{ tagline }}
      </p>
      <div
        class="rte-title"
        :class="{
          'is-dark-mode': isDarkMode,
        }"
        v-html="title"
      ></div>
      <div v-if="sectionIntro">{{ sectionIntro }}</div>
    </div>

    <div
      v-if="paragraphs.length > 0"
      class="space-y-6"
      :class="{
        'text-center': isCenter,
      }"
    >
      <template v-for="(paragraph, index) in paragraphs" :key="paragraph.title + index">
        <div
          class="space-y-2 border-t border-border-light pt-6"
          :class="{
            'text-text-light': isDarkMode,
          }"
        >
          <h3>{{ paragraph.title }}</h3>
          <p>{{ paragraph.text }}</p>
        </div>
      </template>
    </div>

    <div
      v-if="primaryButton || secondaryButton"
      class="mt-6 flex flex-col gap-4 sm:flex-row"
      :class="{
        'justify-center': isCenter,
      }"
    >
      <div class="w-full sm:w-auto">
        <BaseButton
          v-if="primaryButton"
          variant="primary"
          :darkmode="isDarkMode"
          class="w-full sm:w-auto"
          :text="primaryButton.text"
          :url="primaryButton.url"
          :target="primaryButton.target"
        >
        </BaseButton>
      </div>

      <div class="w-full sm:w-auto">
        <BaseButton
          v-if="secondaryButton"
          variant="secondary"
          :darkmode="isDarkMode"
          class="w-full sm:w-auto"
          :text="secondaryButton.text"
          :url="secondaryButton.url"
          :target="secondaryButton.target"
          >{{ secondaryButton.text }}
        </BaseButton>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { IBaseSectionHeader } from '@/common/components/base/BaseSectionHeader/IBaseSectionHeader'
import BaseButton from '@/common/components/base/BaseButton/BaseButton.vue'
import { getBgColor } from '@/common/utils/getBgColor.ts'

const props = withDefaults(defineProps<IBaseSectionHeader>(), {
  isCentered: true,
})

const isDarkMode = computed(() => props.variant == 'blue')

const isCenter = computed(() => props.alignment == 'center')

const bgColor = computed(() => getBgColor(props.variant))
</script>
